import {
    post
} from '../xhr';
import Cookies from 'js-cookie'


export async function signUp({ name, email, password}) {
    return post('/auth/check-record', 'application/json', {
        record: email
    }).then((res) => {
        if (!res.data.exists) {
            return post('/auth/signup', 'application/json', {
                email,
                password,
                name
            })
        }else{
            throw Error('Record already exist')
        }
    })
}

export function signIn({email, password }) {
    return post('/auth/signin', 'application/json', {
        email,
        password
    })
}

export function checkIfRecordExists(record) {
    return post('/auth/check-record', 'application/json', {
        record,
    })
}

export function verifyAccount(userId, token, authToken) {
    console.log(userId)
    return post(`/auth/verify-account/${userId}`, 'application/json', {
        token
    })
}

export function resendVerificationEmail(token) {
    return post('/auth/resend-verification-mail', 'application/json', { })
}

export function signOut() {
    return post('/auth/signout', 'application/json', {})
}


export function forgetPassword(email) {
    return post('/password/send-reset-mail', 'application/json', {
        email
    })
}

export function resetPassword({token, password}) {
    return post(`/password/reset/${token}`, 'application/json', {
        password
    })
}

export function getAuthToken() {
    // const authState = localStorage.getItem('ur-auth');
    // return authState ? JSON.parse(authState).state.token : null;
    const token = Cookies.get('auth:token');
    return token;
}

export function getAuthenticatedUser() {
    const authState = localStorage.getItem('ur-auth');
    return JSON.parse(authState).state.user;
}

export function refresh(token) {
    return post('/auth/refresh', 'application/json', {});
}


export function confirmToken(tkn) {
    return post('/auth/verify-token', 'application/json', {
        token: tkn
    });
}

export function setToken(token) {
    var inSixtyMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
    Cookies.set('auth:token', token, {
        expires: inSixtyMinutes
    })
}